import React from 'react';
import PropTypes from 'prop-types';

import s from './MapNoteSheetEditable.module.scss';

const MapNoteSubject = props => {
    const onChange = e => props.onTextChange(e.target.value);
    const clearPlaceholder = e => (e.target.placeholder = '');
    const showPlaceholder = e => (e.target.placeholder = props.placeholder);
    return <input data-testid="map-note-subject" className={s.enterText} onChange={onChange} placeholder={props.placeholder} value={props.text} onFocus={clearPlaceholder} onBlur={showPlaceholder} />;
};

MapNoteSubject.propTypes = {
    placeholder: PropTypes.string,
    text: PropTypes.string,
    onTextChange: PropTypes.func.isRequired,
};
MapNoteSubject.defaultProps = {
    placeholder: 'Enter text here...',
    text: '',
};

export default MapNoteSubject;
